import memoize from 'memoize-one';
export const getUserEnvironment = memoize((state, environmentId) => {
    const envStore = state.get('userEnvironmentStore');
    const environments = envStore.get('environments');
    const env = environments.find((e) => e.id === environmentId);
    return env;
});
